import { render, staticRenderFns } from "./RetrievePassword.vue?vue&type=template&id=b8785ca2&scoped=true"
import script from "./RetrievePassword.vue?vue&type=script&lang=js"
export * from "./RetrievePassword.vue?vue&type=script&lang=js"
import style0 from "./RetrievePassword.vue?vue&type=style&index=0&id=b8785ca2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8785ca2",
  null
  
)

export default component.exports